(function () {
  'use strict';

  angular.module('app').component('billStatusLabel', billStatusLabel());

  function billStatusLabel() {
    return {
      bindings: {
        status: '<',
        dueDate: '<',
      },
      controller: BillStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}{{ vm.statusDays }}' +
        '</span>',
    };
  }

  BillStatusLabelComponent.$inject = ['$translate', 'moment'];

  function BillStatusLabelComponent($translate, moment) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass = 'default';
      let statusIcon = '';
      let statusTitle = 'DRAFT';

      vm.statusDays = '';

      switch (vm.status) {
        case 'draft':
          statusClass = 'default';
          statusTitle = 'DRAFT';
          break;
        case 'due':
          let dueDate = moment(vm.dueDate, 'YYYY-MM-DD').hours(0);
          let current = moment().startOf('day').hours(0);

          let days = moment.duration(dueDate.diff(current)).asDays();
          let preposition = '';

          if (days < 0) {
            statusClass = 'warning';
            statusTitle = 'OVERDUE';
            preposition = 'BY';
            days = days * -1;
          } else {
            statusClass = 'primary';
            statusTitle = 'DUE';
            preposition = 'IN';
          }

          vm.statusDays =
            ' ' + $translate.instant(preposition) + ' ' + days + ' ' + $translate.instant('DAYS');
          break;
        case 'paid':
          statusClass = 'success';
          statusTitle = 'PAID';
          break;
        case 'unpaid':
          statusClass = 'danger';
          statusTitle = 'UNPAID';
          break;

        case 'inbox': // TODO: kevin needed ?
          statusClass = 'default';
          statusTitle = 'INBOX';
          break;

        case '-': // TODO: kevin needed ?
          statusClass = '-';
          statusTitle = 'No Billed';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
